import axios from "axios";

function getQueryString() {
  var qd = {};

  if (location.search)
    location.search
      .substr(1)
      .split("&")
      .forEach(function(item) {
        var s = item.split("="),
          k = s[0],
          v = s[1] && decodeURIComponent(s[1]); //  null-coalescing / short-circuit
        (qd[k] = qd[k] || []).push(v); // null-coalescing / short-circuit
      });

  return qd;
}

export async function login(QUERY) {
  var qd = getQueryString();

  const form = {};

  if ("QUERY" in qd) {
    form["QUERY"] = QUERY;
  }

  if ("query" in qd) {
    form["query"] = QUERY;
  }

  const response = await axios.post(
    `${process.env.VUE_APP_BASE_API_URL}/sfdc/api/fortune/login`,
    form,
    {
      headers: {
        "x-application-secret-key": process.env.VUE_APP_SECRET_KEY,
      },
    }
  );

  return response.data;
}

const gwapi = axios.create({
  timeout: 120000,
  baseURL: process.env.VUE_APP_BASE_API_URL,
});

gwapi.interceptors.request.use(function(config) {
  config.headers.Authorization = `Bearer ${localStorage.getItem(
    "accessToken"
  )}`;
  return config;
});

gwapi.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status === 401) {
      console.error(`Unauthorized`);
    }
    return Promise.reject(error);
  }
);

export async function finish() {
  const { data } = await gwapi.post(`/sfdc/api/fortune/finish_play`);
  return data;
}
